import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const BahrainFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is Bahrain Attestation and why do I need it?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Bahrain Attestation is the official verification process required
              by Bahrain authorities to confirm that your documents—degree,
              marriage, birth, or commercial—are genuine. You need Bahrain
              attestation for:
              <ul>
                <li> Employment Visa</li>
                <li> LMRA Registration</li>
                <li> Family Visa/Dependents Visa</li>
                <li> Higher Studies</li>
                <li> Business Setup</li>
              </ul>
              Without attestation, Bahrain Ministries, employers, and
              institutions will not accept your documents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Bahrain Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              The processing time varies based on the document type:
              <ul>
                <li>
                  {" "}
                  <b>Educational Certificates:</b> 7–12 working days
                </li>
                <li>
                  {" "}
                  <b>Personal Certificates:</b> 10–15 working days
                </li>
                <li>
                  {" "}
                  <b>Commercial Certificates:</b> 10–18 working days
                </li>
              </ul>
              Express service can speed this up to 5–7 working days
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents are required for Bahrain Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You typically need:
              <ul>
                <li> Original Certificate</li>
                <li> Passport Copy</li>
                <li> Marksheet copies (for educational docs)</li>
                <li> Authorization Letter (if using agency)</li>
                <li> Visa Copy (if available)</li>
              </ul>
              Some personal documents may require Municipality/Notary
              verification before attestation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What are the steps involved in the Bahrain Attestation process?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              A complete Bahrain attestation process includes:
              <ul>
                <li> 1. Notary Attestation</li>
                <li>2. State HRD / SDM / Home Department Attestation</li>
                <li>3. MEA Attestation (Ministry of External Affairs)</li>
                <li>4. Bahrain Embassy Attestation (India)</li>
                <li>5. MOFA Attestation – Bahrain (if required by employer)</li>
              </ul>
              A professional agency handles all steps without you needing to
              visit any office.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is MOFA Bahrain attestation mandatory?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, for most employment and visa processes. MOFA (Ministry of
              Foreign Affairs, Bahrain) attestation is needed for:
              <ul>
                <li> Work Visa</li>
                <li> LMRA Registration</li>
                <li> Visa</li>
                <li> Company Onboarding</li>
              </ul>
              Many companies in Bahrain strictly require MOFA-attested
              documents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents are required for the attestation process ?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <ul>
              <li>Original certificate to be attested</li>
              <li>Passport copy of the certificate holder</li>
              <li>Authorization letter (if applicable)</li>
              <li>Any other supporting documents, if required</li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to give my original documents for attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—if you choose a Government-approved, ISO-certified, and
              well-reviewed agency. A reliable agency provides:
              <ul>
                <li> Receipt for documents</li>
                <li> Tracking number</li>
                <li> Free home pick-up</li>
                <li> Secure processing</li>
              </ul>
              Avoid freelancers or agents with no physical office.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can Bahrain Attestation be done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, trusted agencies offer:
              <ul>
                <li> Free Home Pickup & Drop</li>{" "}
                <li> Doorstep document collection</li>
                <li> Online status tracking</li>
                <li> Online payment</li>
              </ul>
              Convenient for working professionals, students, and families.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of Bahrain Attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Charges depend on the document type and speed:
              <ul>
                <li> Degree Certificate: ₹5,000–₹12,000</li>
                <li> Marriage/Birth Certificate: ₹6,000–₹14,000</li>
                <li> Commercial Documents: ₹12,000–₹25,000</li>
              </ul>
              Cost includes all steps like Notary + State + MEA + Bahrain
              Embassy charges. Express service may cost slightly more.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How do I verify if an attestation agency is genuine?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Choose an agency that is:
              <ul>
                <li> Govt Approved</li>
                <li> ISO Certified</li>
                <li> Has a physical office in Bangalore</li>
                <li> Provides document receipt & tracking</li>
                <li> Has 20,000+ processed files</li>
                <li> Trusted by corporates/MNCs</li>
                <li> Transparent with pricing</li>
              </ul>
              Avoid agents providing only WhatsApp contact with no office
              address.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> Can I get Bahrain Attestation urgently?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, many professional attestation centers offer fast-track or
              express service:
              <ul>
                <li> Processing in 5–7 working days</li>
                <li> Priority handling</li>
                <li> Higher accuracy</li>
              </ul>
              Useful when employers require urgent document submission.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default BahrainFaqMain;
